import { Component, Input, OnDestroy } from '@angular/core';
import { CustomComponent, NestAudit } from '../../../_models/models';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-exchange-audit-details',
  templateUrl: './exchange-audit-details.component.html',
  styleUrls: ['./exchange-audit-details.component.less']
})
export class ExchangeAuditDetailsComponent implements OnDestroy, CustomComponent {
  private _data: NestAudit;

  private readonly unsubscribe$ = new Subject<void>();

  get data() {
    return this._data;
  }
  @Input()
  set data(data) {
    if (data) {
      this._data = data;
    }
  }

  getTableData(): { property: string; oldValue: any; newValue: any }[] {
    const properties: string[] = this.getTableProperties();
    return properties.map((property) => ({
      property: property,
      oldValue: this.formatRowValue(this.data.oldValue[property]),
      newValue: this.formatRowValue(this.data.newValue[property])
    }));
  }

  getTableProperties(): string[] {
    const properties: string[] = [];
    properties.push(...Object.keys(this.data.oldValue));
    properties.push(...Object.keys(this.data.newValue));
    return [...new Set(properties)];
  }


  formatRowValue = (value: any): string => {
    if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('[{'))) {
      return JSON.stringify(JSON.parse(value), null, '\t');
    }
    return JSON.stringify(value, null, '\t');
  };

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
